import { finish, error, clear } from '../../../modules/betslip/actions/place-bet';
import { request as getFreebetCredits } from '../../../modules/customers/actions/get-freebet-credits';

import api from '../../../api';

export async function request(dispatch, { userId, bets, channel, selections, override, isFreeBet, selectedFreeBets }) {
    bets = bets.filter(bet => bet.stakePerLine);
    const selectionIdsWithUuid = await window.$appState.apiEvents.getSelectionsUUID(bets);

    bets.forEach(bet => {
        bet.stakePerLine = Math.round(100 * bet.stakePerLine);

        bet.legs.forEach(leg => {
            leg.type = leg.type || 'standard';
            leg.marketId = parseInt(leg.marketId, 10);

            if (typeof leg.price === 'string') {
                leg.price = { f: leg.price };
            }

            if (leg.type === 'empty') {
                leg.eventName = leg.eventName || 'Event name';
                leg.selectionName = leg.selectionName || 'Selection name';
            }

            const uuid = (leg.type === 'empty' || selectionIdsWithUuid[leg.selectionId] === undefined || selectionIdsWithUuid[leg.selectionId] === null) ? undefined : selectionIdsWithUuid[leg.selectionId].uuid;

            if (uuid === undefined && leg.type !== 'empty') {
                console.error(`No uuid for eventId=${leg.eventId}`);
            }

            if (leg.type === 'empty') {
                leg.uuid = null;
            } else {
                leg.uuid = uuid;

            }

        });
    });

    api.post('/betslip/place-bet', {
        accountId: userId,
        bets,
        channel,
        override,
        isFreeBet,
        selectedFreeBets
    }).then(
        data => {
            if ( isFreeBet ) {
                dispatch( getFreebetCredits( userId ) );
            }

            dispatch(finish(userId, data));

            setTimeout(() => {
                dispatch(clear(userId));
            }, 4000);
        },
        ({ data, errors }) => dispatch(error(userId, Object.assign({}, { errors }, data)))
    );
}
